import { TiMinus, TiPlus } from "react-icons/ti";
import { Switch } from "react-animated-switch";
// import { PiCarDuotone } from "react-icons/pi";
import { IoIosAddCircleOutline } from "react-icons/io";
import styles from "./Addons.module.scss";
import React from "react";

interface AddonItem {
  addonId: number;
  amenityId: number;
  amenityName: string;
  availableNoofAddonunits: number;
  cost: number;
  image: string;
  noofAddonunits: number;
  terms: string;
}

interface AddonSelection {
  addonId: number;
  noofAddonUnits: number;
  notifyAddon: boolean;
}

interface Props {
  addons: AddonItem[];
  addonSelections: AddonSelection[];
  setAddonSelections: React.Dispatch<React.SetStateAction<AddonSelection[]>>;
}

function Addons(props: Props) {
  const { addons, addonSelections, setAddonSelections } = props;

  const getSel = (addonId: number) =>
    addonSelections.find((s) => s.addonId === addonId) ?? {
      addonId: addonId,
      noofAddonUnits: 0,
      notifyAddon: false,
    };

  const updateSel = (addonId: number, patch: Partial<AddonSelection>) => {
    setAddonSelections((prev) => {
      const id = addonId;

      const i = prev.findIndex((s) => s.addonId === id);

      const cur =
        i >= 0
          ? prev[i]
          : {
            addonId: id,
            noofAddonUnits: 0,
            notifyAddon: false,
          };

      const next = { ...cur, ...patch };

      return i >= 0
        ? prev.map((s, j) => (j === i ? next : s))
        : [...prev, next];
    });
  };

  const changeCount = (opt: AddonItem, delta: number) => {
    const s = getSel(opt.addonId);
    const max = opt.noofAddonunits ?? 0;
    const next = s.noofAddonUnits + delta;

    if (next >= 0 && next <= max) {
      updateSel(opt.addonId, { noofAddonUnits: next });
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Addons</p>
        <p className={styles.subHeading}>
          Select addons for your booking
        </p>
      </div>

      {addons?.map((opt) => {
        const s = getSel(opt.addonId);

        const overLimit = s.noofAddonUnits > (opt.availableNoofAddonunits ?? 0);

        const noneAvailable = (opt.availableNoofAddonunits ?? 0) === 0;
        const addonAvailable: boolean = (opt.availableNoofAddonunits ?? 0) > 0;

        const showNotifySwitch = overLimit;

        const hasUserAddedAddon = addonSelections.some(
          (a) => a.addonId === opt.addonId,
        );

        return (
          <div
            key={opt.addonId}
            className={`${styles.parkingGroup} ${hasUserAddedAddon ? styles.userAddedParking : ""}`}
          >
            <div className={styles.iconContainer}>
              <IoIosAddCircleOutline
                className={`${styles.icon} ${addonAvailable ? styles.parkingAvailableIcon : ""}`}
              />
            </div>
            <div className={styles.parkingContentMainContainer}>
              <div className={styles.parkingContentContainer}>
                <div className={styles.labelContainer}>
                  <p className={styles.label}>{opt.amenityName}</p>
                  {(overLimit || noneAvailable) && (
                    <div className={styles.notAvailableContainer}>
                      <p className={styles.label}>Unavailable</p>
                    </div>
                  )}
                </div>
                <div className={styles.availableSpacesContainer}>
                  <p className={styles.spaceText}>{opt.availableNoofAddonunits ?? 0} Units Available</p>
                </div>

                <div className={styles.barContainer}>
                  <div className={styles.bar}>
                    <div
                      className={styles.barFill}
                      style={{
                        width: `${((opt.availableNoofAddonunits ?? 0) / (opt.noofAddonunits ?? 0)) * 100}%`,
                      }}
                    ></div>
                  </div>
                  <p className={styles.barText}>
                    {opt.availableNoofAddonunits ?? 0} / {opt.noofAddonunits ?? 0}{" "}
                    Units
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.counterContainer}>
              <button
                className={styles.counterButton}
                disabled={noneAvailable}
                onClick={() => changeCount(opt, -1)}
              >
                <TiMinus />
              </button>
              <p className={styles.counterValue}>{s.noofAddonUnits}</p>
              <button
                className={styles.counterButton}
                disabled={noneAvailable}
                onClick={() => changeCount(opt, 1)}
              >
                <TiPlus />
              </button>
            </div>
            <div className={styles.priceContainer}>
              <p>$ {(opt.cost ?? 0) * s.noofAddonUnits}</p>
            </div>

            {showNotifySwitch && (
              <div className={styles.noticeContainer}>
                <div className={styles.switchContainer}>
                  <Switch
                    inActiveTrackColor="#DFDFDF"
                    activeTrackColor="#C0F496"
                    inActiveThumbColor="#000000"
                    activeThumbColor="#000000"
                    checked={s.notifyAddon}
                    onChange={(val) =>
                      updateSel(opt.addonId, {
                        notifyAddon: val,
                      })
                    }
                  />
                </div>

                <p className={styles.label}>
                  Notify me when addon is available
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Addons;
